

<template>

  <el-collapse-item name="网格" title="网格">
    <el-form-item label="上">
      <el-input v-model="ele.option.grid.top"></el-input>
    </el-form-item>
    <el-form-item label="下">
      <el-input v-model="ele.option.grid.bottom"></el-input>
    </el-form-item>
    <el-form-item label="右">
      <el-input v-model="ele.option.grid.right"></el-input>
    </el-form-item>
    <el-form-item label="左">
      <el-input v-model="ele.option.grid.left"></el-input>
    </el-form-item>
    <el-form-item label="包含标签">
      <template #label>
        包含标签
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            网格区域是否包含坐标轴的刻度标签。<br>
            为 true 时，常用于『防止标签溢出』的场景<br>
            标签溢出指的是，标签长度动态变化时，可能会溢出容器或者覆盖其他组件
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-switch v-model="ele.option.grid.containLabel" active-color="#55aaff"
                 inactive-color="#cfcfcf">
      </el-switch>
    </el-form-item>
  </el-collapse-item>

</template>

<script>
export default {

  props: {
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },

}

</script>

<style scoped lang="scss">

</style>